export default class Enum<T> {
  static isLocked: boolean;

  value: T;

  constructor(value: T) {
    // @ts-ignore
    if (this.constructor.isLocked) {
      throw new Error(
        `You attempted to add a property to an Enum after it was locked: ${String(value)}`
      );
    }

    if (typeof value === 'undefined') {
      throw new Error('Cannot define an Enum type with no value');
    }

    this.value = value;
  }

  toString(): string {
    return String(this.value);
  }

  static fromValue<T = any>(value: T | undefined): Enum<T> | undefined {
    if (value === undefined) return undefined;
    let found;

    Object.keys(this).forEach((key: string) => {
      if (this[key].value === value) {
        found = this[key];
      }
    });

    return found;
  }

  static values<T = any>(): Array<Enum<T>> {
    return Object.keys(this).reduce(
      (acc: Array<Enum<T>>, key: string) => (this[key] instanceof this ? [...acc, this[key]] : acc),
      []
    );
  }
}



// WEBPACK FOOTER //
// ../shared/js/types/Enum.ts